import gql from "graphql-tag";

export const CREATE_POST = gql`
    mutation CreatePost(
        $subject: String!, $category: String!, $message: String!,
        $tags: [String!], $imagesUrls: [String!], $documentsUrls: [String!]
    ) {
        createPost(input: {
            subject: $subject,
            category: $category,
            message: $message,
            tags: $tags
            imagesUrls: $imagesUrls,
            documentsUrls: $documentsUrls
        }){
            post{
                id
                subject
                category
                message
                created
                imagesUrls
                documentsUrls
                author{
                    id
                    username
                    profile{
                        id
                        displayName
                    }
                }
                commentSet{
                    edges{
                        node{
                            id
                        }
                    }
                }
                tagSet{
                    edges{
                        node{
                            id
                            name
                        }
                    }
                }
            }
        }
    }
`;